<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 7.50024L10 3.75024L13.75 7.50024" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.75 12.5001L10 16.2501L6.25 12.5001" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
